export enum SSEEventType {
	Message = "message",
	Progress = "progress",
	Complete = "complete",
	Error = "error"
}

export const SSE_PREFIXES = {
	Event: "event: ",
	Data: "data: ",
	Comment: ":"
} as const;

export const SSE_PREFIX_LENGTHS = {
	Event: SSE_PREFIXES.Event.length,
	Data: SSE_PREFIXES.Data.length
} as const;
